import React from "react";
import { Link } from "react-router-dom";
import { VersionStatusPill, ActivePill, formatDateTime } from "pages/StandardTreatment/shared/ui";
import { VERSION_STATUS } from "../constants";

// Version hanya punya nomor, status, dan clone lineage (openapi: Version). Tidak ada nama.
// change_note milik Release (diisi saat rilis) dan Rule — bukan milik Version.
const VersionInfoStep = ({ version, isActive, summary }) => (
  <>
    <dl className="mps-version-grid">
      <div>
        <dt>Nomor versi</dt>
        <dd className="mps-version-number">Versi {version.version}</dd>
      </div>
      <div>
        <dt>Status</dt>
        <dd className="d-flex flex-wrap" style={{ gap: 6 }}>
          <VersionStatusPill status={version.status} />
          {isActive && <ActivePill />}
        </dd>
      </div>
      <div>
        <dt>Asal versi</dt>
        <dd>
          {version.clone_from_version ? `Diklon dari Versi ${version.clone_from_version}` : "Draft kosong / seed"}
        </dd>
      </div>
      <div>
        <dt>Isi versi</dt>
        <dd>
          {summary
            ? `${summary.rule_count} rule · ${summary.condition_count} kondisi · ${summary.therapy_count} terapi`
            : "…"}
        </dd>
      </div>
      <div>
        <dt>Dibuat</dt>
        <dd>{formatDateTime(version.createdAt)}</dd>
      </div>
      <div>
        <dt>Diperbarui</dt>
        <dd>{formatDateTime(version.updatedAt)}</dd>
      </div>
    </dl>

    <p className="mps-helper mb-0">
      {VERSION_STATUS[version.status].hint}. Versi aktif ditentukan oleh release terbaru, bukan oleh
      status. Rule versi ini dikelola di{" "}
      <Link to={`/standard-treatment/rules?version_id=${version.id}`}>Daftar Rules</Link>; catatan rilis
      diisi saat versi dirilis.
    </p>
    {version.status === "DRAFT" && (
      // HANDOFF §10: tidak ada locking pada Draft.
      <p className="md-warning mt-3 mb-0">
        Draft tidak dikunci: bila dua Administrator menyunting Draft yang sama, perubahan terakhir
        menimpa yang lain tanpa peringatan.
      </p>
    )}
  </>
);

export default VersionInfoStep;
